import { reactive, onMounted } from "vue";
import { postMatchChampionList } from "@/api/home-page";
import { championRaceTime } from "@/config/homePage";

export function useRaceHonors() {
  const raceHonorsState = reactive({
    raceQuartertype: 10, // 赛季季度类型
    groupType: 1, // 组别类型
    showPreview: false,
  });

  onMounted(() => {
    raceHonorsState.groupType = getCurrentCampionRace();
    console.log('raceHonorsState.groupType', raceHonorsState.groupType)
    fetchChampionshipList();
  });

  // 筛选已结束且最近的比赛组别
  function getCurrentCampionRace() {
    let current = new Date().getTime();
    let currentRace = championRaceTime[raceHonorsState.raceQuartertype]
      .filter((item) => item.time <= current)
      .sort((a, b) => a - b);
      console.log('currentRace',currentRace)
    if (currentRace.length === 3) {
      return 3
    } else {
      return currentRace?.[0]?.value
    }
  }
  // 赛季季度切换
  function raceQuarterSwitchFct(val) {
    raceHonorsState.raceQuartertype = val.value;
    fetchChampionshipList();
  }

  // 组别类型切换
  function groupSwitchFct(val) {
    raceHonorsState.groupType = val.value;
    fetchChampionshipList();
  }
  // 显示详情
  function showDetail() {
    raceHonorsState.showPreview = true;
  }
  // 获取冠军赛列表
  const fetchChampionshipList = async () => {
    try {
      const res = await postMatchChampionList({
        matchGroup: raceHonorsState.groupType,
        matchSeason: raceHonorsState.raceQuartertype,
        matchSession: 3,
        matchZone: 1,
      });
      if (res.code === 0) {
        raceHonorsState.teamInfo = res.data.list[2]
          ? res.data.list[2][0].red_match_team
          : {};
        return res.data;
      }
    } catch (error) {
      console.warn("获取冠军赛列表失败", error);
    }
    return {};
  };

  return {
    raceHonorsState,
    raceQuarterSwitchFct,
    groupSwitchFct,
    showDetail,
  };
}

export default useRaceHonors;
